const LAST_TRUSTED_SERVER_TIME_KEY = 'last_trusted_server_time';
const TRUSTED_SERVER_LOCAL_ANCHOR_KEY = 'trusted_server_local_anchor';
const LAST_OBSERVED_LOCAL_TIME_KEY = 'last_observed_local_time';

/** Détection des retours en arrière significatifs de l’horloge système. */
export class ClockTamperGuard {
  private static memory = new Map<string, string>();

  static async recordTrustedServerTime(iso: string): Promise<void> {
    await ClockTamperGuard.setItem(LAST_TRUSTED_SERVER_TIME_KEY, iso);
    const localNow = new Date().toISOString();
    await ClockTamperGuard.setItem(TRUSTED_SERVER_LOCAL_ANCHOR_KEY, localNow);
    await ClockTamperGuard.setItem(LAST_OBSERVED_LOCAL_TIME_KEY, localNow);
  }

  static async observeStartup(): Promise<{ suspicious: boolean; message?: string }> {
    const now = Date.now();
    const lastObserved = await ClockTamperGuard.getItem(LAST_OBSERVED_LOCAL_TIME_KEY);
    await ClockTamperGuard.setItem(LAST_OBSERVED_LOCAL_TIME_KEY, new Date(now).toISOString());

    if (!lastObserved) return { suspicious: false };

    const lastMs = new Date(lastObserved).getTime();
    const driftMs = lastMs - now;
    if (driftMs > 24 * 3600 * 1000) {
      return {
        suspicious: true,
        message:
          'L’horloge système semble avoir reculé. Connectez-vous à Internet pour resynchroniser la licence.',
      };
    }
    return { suspicious: false };
  }

  private static async getItem(key: string): Promise<string | null> {
    if (window.electron?.secureStoreGet) {
      return window.electron.secureStoreGet(key);
    }
    return ClockTamperGuard.memory.get(key) ?? null;
  }

  private static async setItem(key: string, value: string): Promise<void> {
    if (window.electron?.secureStoreSet) {
      await window.electron.secureStoreSet(key, value);
      return;
    }
    ClockTamperGuard.memory.set(key, value);
  }

  static __resetForTests(): void {
    ClockTamperGuard.memory.clear();
  }

  static __setLastObservedForTests(iso: string): void {
    ClockTamperGuard.memory.set(LAST_OBSERVED_LOCAL_TIME_KEY, iso);
  }
}
